import axios from './axios';
import { LoginParams, LoginResponse } from '../types/auth';

export interface RegisterParams {
  userName: string;
  password: string;
  email?: string;
  phoneCountryCode?: string;
  phone?: string;
  nickName?: string;
  role?: string;
  country?: string;
  city?: string;
  /** 邀请码（选填） */
  inviteCode?: string;
  /** 注册页界面语言（i18n code） */
  language?: string;
}

export const login = async (params: LoginParams) => {
  try {
    const response = await axios.post<LoginResponse>('/api/users/auth/login', params);
    return response;
  } catch (error) {
    console.error('Login API error details:', error);
    throw error;
  }
};

export const logout = () => {
  return axios.post('/api/users/auth/logout');
};

export const getCurrentUser = () => {
  return axios.get('/api/users/auth/me');
};

export const register = async (params: RegisterParams) => {
  console.log('Register API called with params:', {
    ...params,
    password: params.password ? '******' : undefined
  });
  
  try {
    const response = await axios.post('/api/users/auth/register', params);
    console.log('Register API response:', {
      status: response.status,
      data: response.data
    });
    return response;
  } catch (error) {
    console.error('Register API error details:', error);
    throw error;
  }
};

export type IdentifierCheckType = 'username' | 'email' | 'phone';

/** 联合查重：登录标识符在用户名/邮箱/手机号之间不能交叉重复 */
export const checkIdentifierExists = async (
  type: IdentifierCheckType,
  value: string,
  phoneCountryCode?: string,
): Promise<boolean> => {
  if (!value) return false;
  try {
    const response = await axios.post<{ data: { exists: boolean } }>(
      '/api/users/auth/check-identifier',
      { type, value, phoneCountryCode },
    );
    return response.data?.data?.exists === true;
  } catch (error) {
    console.error('Check identifier exists error:', error);
    return false;
  }
};

export const checkUsernameExists = (username: string) =>
  checkIdentifierExists('username', username);

export const checkEmailExists = (email: string) =>
  checkIdentifierExists('email', email);

export const checkPhoneExists = (phone: string, countryCode?: string) =>
  checkIdentifierExists('phone', phone, countryCode); 